// src/pages/Home/components/Navbar3/utils/navbar3.utils.js

export const cx = (...classes) =>
  classes.filter(Boolean).join(" ");

export const getStoredUserInfo = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const storedUserInfo =
      localStorage.getItem("userInfo");

    return storedUserInfo
      ? JSON.parse(storedUserInfo)
      : null;
  } catch (error) {
    console.error(
      "Erreur lors de la lecture de userInfo :",
      error,
    );

    return null;
  }
};

export const formatBadgeCount = (count) => {
  const numericCount = Number(count) || 0;

  return numericCount > 99
    ? "99+"
    : numericCount;
};

export const isPathActive = (
  currentPath,
  itemPath,
) => {
  if (!currentPath || !itemPath) {
    return false;
  }

  if (itemPath === "/") {
    return currentPath === "/";
  }

  return (
    currentPath === itemPath ||
    currentPath.startsWith(
      `${itemPath}/`,
    )
  );
};

export const getMenuBadgeMeta = (
  badgeType,
) => {
  switch (badgeType) {
    case "messages":
      return {
        label: "non lu",
        pluralLabel: "non lus",
        className:
          "bg-rose-600 text-white",
      };

    case "convocations":
      return {
        label: "en attente",
        pluralLabel: "en attente",
        className:
          "bg-yellow-400 text-slate-950",
      };

    case "votes":
      return {
        label: "à effectuer",
        pluralLabel: "à effectuer",
        className:
          "bg-amber-400 text-slate-950",
      };

    default:
      return {
        label: "",
        pluralLabel: "",
        className:
          "bg-slate-600 text-white",
      };
  }
};